import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as Router } from "react-router-dom";
import { store } from './store';
import { MDRoutes } from './routes';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import './index.css';
import { history } from './utils';
import ReactGA from 'react-ga4';
import { ConfigProvider, App as AntdApp } from 'antd';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { AntdAppMessageBridge } from './components/common/MessageNotification/AntdAppMessageBridge';


// Define your color themes here
const themes = {
  green: {
    primaryColor: '#315e45',
    highlighterColor: '#f9f3ee',
    lightShadowColor: '#9ad69C',
    sideNavigation: '#315e45',
    fontColor: 'white',
  },
  purple: {
    primaryColor: '#722ed1',
    highlighterColor: '#b37feb',
    lightShadowColor: '#f9f0ff',
    sideNavigation: '#722ed1',
    fontColor: '#fff',
  },
  blue: {
    primaryColor: '#1677ff',
    highlighterColor: '#bae0ff',
    lightShadowColor: '#e6f4ff',
    sideNavigation: '#1677ff',
    fontColor: '#fff',
  },
  orange: {
    primaryColor: '#de7f39',
    highlighterColor: '#ffc069',
    lightShadowColor: '#fff4ec',
    sideNavigation: '#de7f39',
    fontColor: '#fff',
  },
};
// Function to select theme based on URL
function getThemeFromUrl() {
  const hostname = window.location.hostname.toLowerCase();
  // Example logic: adjust as needed for your routes/domains
  if (hostname.includes('enterprise.medhaul.link')) return 'green';
  // if (hostname.includes('/blue')) return 'blue';
  // if (hostname.includes('/orange')) return 'orange';
  // Default
  return 'green';
}

// const ACTIVE_THEME = getThemeFromUrl();


const App = () => {
  const { themeVars } = useTheme();


  return (
    <Provider store={store}>
      <ConfigProvider
        theme={
          themeVars
            ? {
              token: {
                colorPrimary: themeVars.primaryColor,
                // colorInfo: themeVars.highlighterColor,
                // colorBgContainer: themeVars.lightShadowColor,
              },
            }
            : undefined
        }
      >
        <AntdApp>
          <AntdAppMessageBridge />
          <Router history={history}>
            <MDRoutes />
          </Router>
        </AntdApp>
      </ConfigProvider>
    </Provider>
  );
};

ReactDOM.createRoot(
  document.getElementById("root"),
)
  .render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </Provider>
    </React.StrictMode>,
  );

ReactGA.initialize('G-BJV8X8T2QZ', {
  gaOptions: {
    siteSpeedSampleRate: 100,
    alwaysSendReferrer: true,
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
